const styles = {
  heading: {
    fontSize: "24px",
    fontWeight: "600",
  },
};

export default styles;
